import { RouteQueryParams } from '@lsq-frontend/angular-shared/app-constants';

export class FastTrackRouteQueryParams extends RouteQueryParams {
    public static VerificationCode = 'verificationCode';
    public static MultiFactorAuthenticationSetup = 'mfaSetup';
    public static IsEnrolled = 'isEnrolled';
    public static HasNewNetworkRequest = 'hasNewNetworkRequest';
    public static PreviousRouteId = 'previousRouteId';
    public static InvoiceTypeFilter = 'invoiceTypeFilter';
    public static PaymentTypeFilter = 'paymentTypeFilter';
    public static SearchText = 'searchText';
    public static DateFilter = 'dateFilter';
    public static PayerFilter = 'payerFilter';
    public static Redirect = 'redirect';
    public static StartDate = 'startDate';
    public static EndDate = 'endDate';
    public static SellerEnrollmentToken = 'sellerEnrollmentToken';
    public static OperationsBuyerIsImplementation = 'isImplementation';
    public static InvoicesTab = 'invoices';
    public static PendingCreditMemosTab = 'pending-credit-memos';
    public static ProspectId = 'prospectId';
    public static ShowPasswordReset = 'showPasswordReset';
    public static InvoiceBatchKey = 'k';
    public static ShowUpdateMfaModal = 'showUpdateMfaModal';
    public static SupplierKeysFilter = 'supplierKeysFilter';
    public static BuyerKeysFilter = 'buyerKeysFilter';
    public static InvoiceStatusFilter = 'invoiceStatusFilter';
    public static IsPayerLSQ = 'isPayerLSQ';
    public static GroupedInvoiceType = 'groupedInvType';
    public static PurchaseRequestsUploads = 'uploads';
    public static PurchaseRequestsExistingRequests = 'existing';
}
